export default [
  { name: 'id', label: 'ID', type: 'immutable' },
  { name: 'name', label: 'Name' }
]



// WEBPACK FOOTER //
// ./src/fields/products.js